import type { ReactNode } from "react";

export default function Shell({ children }: { children: ReactNode }) {
  return (
    <div
      className="max-w-[1440px] mx-auto px-6 sm:px-8 lg:px-12 py-8"
      style={{
        paddingTop: '64px',
        position: 'relative'
      }}
    >
      {children}
    </div>
  );
}
